import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

import { useProfile, useUpdateLanguage } from "../profileApi";

/**
 * Сверка языка UI ↔ языка профиля (2026-08-12, аудит V1).
 *
 * У языка два источника: локаль интерфейса (localStorage, i18n) и
 * User.language в профиле — от него говорят ВСЕ серверные тексты (утренний
 * бриф, письма, TG-уведомления). Settings пишет в оба, но язык, выбранный
 * до логина (лендинг, инвайт) или оставшийся от регистрации, расходился
 * навсегда: интерфейс на русском, бриф — «Readiness 87%, fitness 76.
 * Today on plan».
 *
 * Направление синка: UI → профиль. Пользователь видит интерфейс — сервер
 * обязан говорить на том же языке; при двух устройствах побеждает последнее
 * использованное (правильно для уведомлений). Один запрос за монтирование
 * и только при фактическом расхождении.
 */
export function LanguageProfileSync() {
  const { i18n } = useTranslation();
  const { data: profile } = useProfile();
  const update = useUpdateLanguage();
  const done = useRef(false);

  useEffect(() => {
    if (done.current || !profile) return;
    const ui = (i18n.language || "").slice(0, 2).toLowerCase();
    if (!ui) return;
    done.current = true;
    if (profile.language && profile.language !== ui) {
      update.mutate(ui);
    }
  }, [profile, i18n.language, update]);

  return null;
}
